import { Lightbulb, ExternalLink } from "lucide-react";
import { STEP_HERO } from "./stepHero";

export function StepHero({ stepKey }) {
  const h = STEP_HERO[stepKey];
  if (!h) return null;
  return (
    <div className="mb-4 rounded-xl border border-violet-100 bg-violet-50/60 p-3.5 sm:p-4" data-testid={`setup-hero-${stepKey}`}>
      <div className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.16em] text-violet-700">
        <Lightbulb size={12} /> Why this matters
      </div>
      <p className="mt-1.5 text-sm text-zinc-700 leading-relaxed">{h.why}</p>
      <ul className="mt-2.5 space-y-1">
        {h.tips.map((t) => (
          <li key={t} className="flex items-start gap-2 text-xs text-zinc-600">
            <span className="mt-[6px] h-1.5 w-1.5 shrink-0 rounded-full bg-violet-400" />{t}
          </li>
        ))}
      </ul>
      {h.link && (
        <a href={h.link.href} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-violet-700 hover:underline" data-testid={`setup-hero-link-${stepKey}`}>
          {h.link.label} <ExternalLink size={12} />
        </a>
      )}
    </div>
  );
}
